/** Active state for primary nav and nested settings links */
export function isNavPathActive(path: string, pathname: string): boolean {
  const base = path.startsWith('/') ? path : `/${path}`;
  if (base === '/dashboard') {
    return pathname === '/dashboard' || pathname.startsWith('/dashboard/');
  }
  // Parent "Settings" only — path in menu data is the literal `settings`, not `/settings/users`, etc.
  if (path === 'settings' || base === '/settings') {
    return pathname.startsWith('/settings');
  }
  // Concrete routes (including /settings/users, /settings/integration, …)
  return pathname === base || pathname.startsWith(`${base}/`);
}
